import React from "react";
import styled from "styled-components";

function Container({ children }) {
  return <Wrapper>{children}</Wrapper>;
}

export default Container;

const Wrapper = styled.div`
  min-width: 0;
  width: 100%;
  max-width: 1140px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 2rem;
  padding-right: 2rem;
  @media (max-width: 767px) {
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;
